export const getCompetitionLabel = (sportName?: string, competitionName?: string): string => {
    if (!sportName && competitionName) {
        return competitionName;
    }

    if (!competitionName && sportName) {
        return sportName;
    }

    if (sportName && competitionName) {
        return `${sportName}, ${competitionName}`;
    }

    return '';
};
